<div class="loader-container">
    <app-loader *ngIf="loading"></app-loader>
    <app-modal-header *ngIf="modalStyle" [title]="modalTitle"></app-modal-header>
    <div [ngClass]="{ 'modal-body': modalStyle }">
        <div *ngIf="errorMessage" class="alert alert-danger d-flex align-items-center" role="alert">
            <div>{{ errorMessage }}</div>
        </div>

        <div *ngIf="productList.length > 0" class="row mb-3">
            <div class="col-12">
                <input [(ngModel)]="search" type="text" placeholder="Zoeken.." class="form-control mb-2">
                <div class="tableScroll">
                    <table class="table">
                        <thead>
                            <tr>
                                <th></th>
                                <th class="pointer" (click)="sortGroups()">
                                    Methode
                                    <span *ngIf="sortDirection === 'asc'"><i class="bi bi-sort-down"></i></span>
                                    <span *ngIf="sortDirection === 'desc'"><i class="bi bi-sort-up"></i></span>
                                </th>
                                <th>Product</th>
                                <th>EAN</th>
                                <th>Hoeveelheid</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let group of groupedProducts">
                                <ng-container *ngFor="let product of group.products">
                                    <tr *ngIf="canShow(product)">
                                        <td style="vertical-align: middle;padding-right:30px;">
                                            <input style="margin-top: 5px; width: 20px; height: 20px;" type="checkbox"
                                                [(ngModel)]="product.selected" />
                                        </td>
                                        <td style="vertical-align: middle;padding-right:30px;">
                                            {{ group.method }}
                                        </td>
                                        <td style="vertical-align: middle;">{{ product.name }}</td>
                                        <td style="vertical-align: middle;">{{ product.ean }}</td>
                                        <td style="vertical-align: middle;" (click)="activateProduct(product)" class="product-quantity-input">
                                            <input type="number" class="form-control" [(ngModel)]="product.quantity"
                                                [disabled]="!product.selected" min="1" placeholder="Qty"/>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div class="form-buttons">
            <button type="button" class="btn btn-primary" (click)="addSelectedProducts()">{{ modalButton }}</button>
        </div>
    </div>
</div>